(function($) {

	"use strict";

/** --------------------------------------------------
 * 
 *   THEME SCRIPT
 *
 *   TABLE OF CONTENTS
 *   window load
 *   drupal behavior
 *
 *  -------------------------------------------------- */




/** --------------------------------------------------
    #window load
    -------------------------------------------------- */

	$(window).on('load', function() {
		$(".user-menu-wrapper button, .user-menu-wrapper > nav").hover(
			function() {
			  	$(".user-menu-wrapper").addClass('show-user-menu__desktop');
			}, function() {
				$(".user-menu-wrapper").removeClass('show-user-menu__desktop');
			}
		);
	});




})(jQuery);
